<template>
  <div class="container-fluid">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            Request Audit
          </h4>
          <h6 class="card-subtitle">
            Please keep your profile information always current in order to help you
            when you contact us.
          </h6>
        </div>
        <form @submit.prevent="handleSubmit" class="form-horizontal">
          <div class="card-body card-blue">
            <div class="form-group row">
              <label class="col-sm-3 text-right control-label col-form-label" for="auditor">Auditor</label>
              <div class="col-sm-6">
                <multiselect :class="{'is-invalid': submitted && errors.has('auditor')}" :options="auditing_orgs"
                             class="form-control"
                             data-vv-as="Auditor" id="auditor"
                             label="biz_email" name="auditor" placeholder="Select an auditor" track-by="entity_id"
                             v-model="audit.auditor" v-validate="'required'">
                  <template slot="singleLabel" slot-scope="props">
                    {{ props.option.name }}
                  </template>
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <h5>{{ props.option.name }}</h5>
                      <h6>{{ props.option.description }}</h6>
                    </div>
                  </template>
                </multiselect>
                <div class="invalid-feedback" v-if="submitted && errors.has('auditor')">
                  {{ errors.first('auditor') }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 text-right control-label col-form-label" for="certification">Audit
                Certification</label>
              <div class="col-sm-6">
                <multiselect :class="{'is-invalid': submitted && errors.has('certification')}"
                             :custom-label="customLabel" :option-height="104"
                             :options="certifications" :show-labels="false"
                             class="form-control" data-vv-as="Audit Certification"
                             id="certification" label="title" name="certification"
                             placeholder="Select a certification type"
                             track-by="id" v-model="audit.certification" v-validate="'required'">
                  <template slot="singleLabel" slot-scope="props">
                    <div class="row">
                      <div class="d-flex">
                        <div class="p-l-10 p-r-20">
                          <img :src="props.option.img">
                        </div>
                        <div class="">
                          <h3 class="font-normal">
                            {{ props.option.name }}
                          </h3>
                          <h5 class="font-normal">
                            Version: {{ props.option.version }}
                          </h5>
                          <span class="custom-wrap option__small">{{ props.option.description }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template slot="option" slot-scope="props">
                    <div class="row">
                      <div class="d-flex">
                        <div class="p-l-10 p-r-20">
                          <img :src="props.option.img">
                        </div>
                        <div class="">
                          <h3 class="font-normal">
                            {{ props.option.name }}
                          </h3>
                          <h4 class="font-normal">
                            Version: {{ props.option.version }}
                          </h4>
                          <span class="custom-wrap option__small">{{ props.option.description }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                </multiselect>
                <div class="invalid-feedback" v-if="submitted && errors.has('certification')">
                  {{ errors.first('certification') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-t-20" v-if="audit.certification">
              <label class="col-sm-3 text-right control-label" for="auditor">Select Audit Modules</label>
              <div class="col-sm-6">
                <div :key="impactArea.impact_area" class="form-check"
                     v-for="impactArea in audit.certification.impact_areas">
                  <div class="custom-control custom-checkbox">
                    <input :id="impactArea.impact_area" :name="impactArea.impact_area" :value="impactArea"
                           checked class="custom-control-input" type="checkbox" v-model="audit.impact_areas">
                    <label :for="impactArea.impact_area" class="custom-control-label">{{ impactArea.name }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row"
                 v-if="activeGroup && activeGroup.total_vote_weight > 1 && activeGroup.threshold > 1">
              <label class="col-sm-3 text-right control-label col-form-label" for="comments">Comments </label>
              <div class="col-sm-6">
                <input class="form-control" id="comments" name="comments" placeholder="Comments"
                       type="text" v-model="audit.comments">
              </div>
            </div>

            <div class="card-footer">
              <div class="form-group m-b-0 text-right">
                <div class="button-group">
                  <button class="btn waves-effect waves-light btn-success" type="submit">
                    Save
                  </button>
                  <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="reset">
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import {mapGetters} from 'vuex';
  import {apiMixin} from '@/utils/api-mixin';

  export default {
    name: 'AuditRequest',
    components: {Multiselect},
    mixins: [apiMixin('audit')],
    data() {
      return {
        searchStr: '',
        submitted: false,
        audit: {
          certification: null,
          auditor: null,
          impact_areas: [],
          comments: null
        },
        certifications: [],
        auditing_orgs: [],

        $TIMEOUT: this.$TIMEOUT
      };
    },
    computed: {
      ...mapGetters(['currentUser', 'activeGroup'])
    },
    mounted() {
      console.log(this.activeGroup)
      this.init();
    },
    methods: {
      async init() {
        await Promise.all([
          this.getAuditingOrgs(),
          this.getCertifications()
        ]);
      },

      async getAuditingOrgs() {
        try {
          // TODO: get name from address book
          this.auditing_orgs = [{
            group_id: this.activeGroup.group_id,
            public_key: this.activeGroup.anonymous_account,
            name: this.activeGroup.name,
            description: 'Self Audit'
          }];
          const {data} = await this.$accounts.get('/auditor_registry');
          data.forEach(auditor => this.auditing_orgs.push(auditor));
        } catch (e) {
          console.error(e);
        }
      },
      async getCertifications() {
        try {
          const {data} = await this.$api.get('/audits/certifications');
          this.certifications = data;
          this.certifications.forEach(t => {
            switch (t.name) {
              case 'GAP':
                t.img = '/global-gap.png';
                break;
              case 'RSPO':
                t.img = '/rspo.png';
                break;
              case 'TVSaFE':
                t.img = '/tvsfe.png';
                break;
              default:
                t.img = '/audit_icon.png';
            }
          });
        } catch (e) {
          console.error(e);
        }
      },
      customLabel({title, desc}) {
        return `${title} – ${desc}`;
      },
      handleSubmit() {
        this.submitted = true;
        this.$validator.validate()
          .then(valid => {
            if (valid) {
              this.save();
            }
          });
      },
      reset() {
        this.submitted = false;
        this.audit = {
          certification: null,
          auditor: null,
          impact_areas: [],
          comments: null
        };
      },
      async save() {
        // eslint-disable-next-line no-unused-vars
        let isProposal = false;
        if (this.activeGroup && this.activeGroup.threshold > 1) {
          isProposal = true;
        }
        await this.callApi('loader', isProposal, 'Audit created', async () => {
          await this.$api.post('/audits', {
            auditor: this.audit.auditor.public_key,
            certification_id: this.audit.certification.certification,
            impact_areas: this.audit.impact_areas.map(ia => ia.impact_area),
            comments: this.audit.comments
          });
        });
        this.$router.push({name: isProposal ? 'proposals' : 'myaudits'});
      },
      orgprofile(orgid) {
        const routeData = this.$router.resolve({name: 'orgprofile', params: {orgid: orgid}});
        window.open(routeData.href, '_blank');
      }

    }
  }
</script>

<style scoped>
  .custom-wrap {
    word-wrap: normal;
    /* word-break: break-all; */
    white-space: normal;
    display: block;
    height: auto;
    margin: 3px auto;
    line-height: 1.4;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
</style>
